import API from "./restAPI";
import { AxiosResponse } from "axios";

let config = require("../configuration.json");

export function apiGetAllSellers(): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/sellers`);
}

export function apiGetAllSellersForImportPrices(): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/sellersForImportPrices`);
}

export function apiGetSellerDetail(id: number): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/seller/${id}`);
}

export function apiSellerCreateOrUpdate(data: any): Promise<AxiosResponse> {
  return API.post(`${config.serverUrl}/api/sellercreateorupdate`, data);
}

export function apiDeleteSeller(id: number): Promise<AxiosResponse> {
  return API.delete(`${config.serverUrl}/api/seller/${id}`);
}
